import Vue from 'vue'
import VueRouter from 'vue-router'
import InscripcionView from '../views/InscripcionView.vue'
import SuccessView from '../views/SuccessView.vue'

Vue.use(VueRouter)

const routes = [
  
  {
    path: '',
    name: 'inscripcion',
    component: InscripcionView
  },
  {
    path: '/success',
    name: 'success',
    component: SuccessView
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
